'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var delimiters = exports.delimiters = function delimiters(svg, scales, x, dateFormat) {
    var extremum = svg.select('.extremum');
    var domain = scales.x.domain();

    extremum.selectAll('.minimum').remove();
    extremum.selectAll('.maximum').remove();

    extremum.append('text').text(dateFormat(domain[0])).classed('minimum', true);

    extremum.append('text').text(dateFormat(domain[1])).classed('maximum', true).attr('transform', 'translate(' + (scales.x.range()[1] - x) + ')').attr('text-anchor', 'end');
};
//# sourceMappingURL=delimiters.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/ansyn-event-drops/dist-es5/drawer/delimiters.js
// module id = ../../../../ansyn-event-drops/dist-es5/drawer/delimiters.js
// module chunks = vendor